var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15112 9.20859L3.83695 11.8944M3.83695 11.8944L6.52277 9.20859M3.83695 11.8944V1.15112M13.2373 3.83695L10.5515 1.15112M10.5515 1.15112L7.86568 3.83695M10.5515 1.15112V11.8944",
    stroke: "white",
    strokeWidth: 2.30213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrowIcon);
export default __webpack_public_path__ + "static/media/UpDownArrowIcon.48b321f675dd69883bec69e0efd152c0.svg";
export { ForwardRef as ReactComponent };